import { configureStore } from "@reduxjs/toolkit";
import { profileSlice } from "./slices/profile-slice";
import { applicationSlice } from "./slices/application-slice";
import { signInSlice } from "./slices/signed-in-slice";
import { jobDataSlice } from "./slices/job-data-slice";
import { uploadSlice } from "./slices/upload-slice";
import { profileStatusSlice } from "./slices/profile-status-slice";
import { jobsSlice } from "./slices/job-listings-slice";
import { email2faVerifiedSlice } from "./slices/email-2fa-verified-slice"
import { individualAssessmentsSlice } from "./slices/individual-assessment-listings-slice";
import { lastSelectedJobSlice } from "./slices/last-selected-job-slice";
import { deleteUploadSlice } from "./slices/delete-upload-slice";
import { profileEmploymentStatusSlice } from "./slices/profile-employment-status-slice";

export const store = configureStore({
    reducer: {
        profile: profileSlice.reducer,
        application: applicationSlice.reducer,
        signInSlice: signInSlice.reducer,
        jobDataSlice: jobDataSlice.reducer,
        uploadSlice: uploadSlice.reducer,
        profileStatus: profileStatusSlice.reducer,
        jobsSlice: jobsSlice.reducer,
        email2faVerifiedSlice : email2faVerifiedSlice.reducer,
        individualAssessmentsSlice: individualAssessmentsSlice.reducer,
        lastSelectedJobSlice: lastSelectedJobSlice.reducer,
        deleteUploadSlice: deleteUploadSlice.reducer,
        profileEmploymentStatusSlice: profileEmploymentStatusSlice.reducer 
    }
});
